module.exports = __webpack_public_path__ + "static/media/i52.a03b585a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i52.png
// module id = 155
// module chunks = 12